const RELOAD_KEY = 'chunkReloadAt';
const PENDING_RELOAD_KEY = 'chunkReloadPending';
const RELOAD_THROTTLE_MS = 10000;
const CHUNK_FAILED = /Loading( CSS)? chunk [\w-]+ failed/i;

export function isChunkLoadError(error) {
  return !!error && CHUNK_FAILED.test((error && error.message) || '');
}

function doReload() {
  const last = parseInt(window.sessionStorage.getItem(RELOAD_KEY) || '0', 10);
  if (Date.now() - last <= RELOAD_THROTTLE_MS) return false;

  window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

// Used for vue-router's onError: the user just navigated somewhere that
// depends on a stale chunk (e.g. after a deploy rotated the build's chunk
// hashes), so there's no unrelated in-progress interaction to interrupt.
export function reloadOnChunkError(error) {
  if (!isChunkLoadError(error)) return false;
  doReload();
  return true;
}

// Used for lazy components loaded outside of navigation (modals, background
// widgets that can pop up seconds after the page already rendered). Reloading
// immediately here would yank the user out of whatever they're doing, so just
// remember the stale build and let the next real navigation do the reload.
export function deferReloadOnChunkError(error) {
  if (!isChunkLoadError(error)) return false;
  window.sessionStorage.setItem(PENDING_RELOAD_KEY, '1');
  return true;
}

// Call from the router's navigation guard so a deferred reload happens at a
// natural transition point instead of mid-interaction.
export function consumePendingChunkReload() {
  if (window.sessionStorage.getItem(PENDING_RELOAD_KEY) !== '1') return;
  if (doReload()) {
    window.sessionStorage.removeItem(PENDING_RELOAD_KEY);
  }
}

// Wraps a dynamic-import factory (e.g. `() => import('./x.vue')`) so a failed
// chunk fetch triggers the deferred reload guard. Re-throws so Vue does not
// try to render a broken async component. Use for lazy Vue components (async
// component load failures are not surfaced through vue-router's onError).
export function lazyWithReload(loader) {
  return () => loader().catch((error) => {
    deferReloadOnChunkError(error);
    throw error;
  });
}

// Wraps every value of a { name: () => import(...) } map with lazyWithReload.
export function lazyComponents(map) {
  return Object.keys(map).reduce((acc, key) => {
    acc[key] = lazyWithReload(map[key]);
    return acc;
  }, {});
}



// WEBPACK FOOTER //
// ./src/helpers/reloadOnChunkError.js